export default {
	title: 'Device Management',
	actions: {
		add: 'Add',
		edit: 'Edit',
		delete: 'Delete',
		batchDelete: 'Batch Delete',
		save: 'Save',
		cancel: 'Cancel',
		confirm: 'Confirm'
	},
	messages: {
		deleteSuccess: 'Delete successful',
		actionSuccess: 'Operation successful',
		noValidSensor: 'Please fill in at least one complete sensor information'
	},
	labels: {
		deviceList: 'Device List',
		startStopRecord: 'Start-Stop Record',
		diagnose: 'Diagnose',
		node: 'Node',
		device: 'Device',
		sensor: 'Sensor',
		org: 'Organization',
		addNode: 'Add {type}',
		editNode: 'Edit {type}'
	},
	table: {
		name: 'Name',
		deviceTypeId: 'Device Type',
		status: 'Status',
		action: 'Action'
	},
	form: {
		placeholder: {
			name: 'Please enter name',
			deviceTypeId: 'Please select device type'
		}
	},
	dialog: {
		add: 'Add',
		edit: 'Edit',
		addDevice: 'Add Device',
		addSensor: 'Add Sensor',
		addOrg: 'Add Organization',
		editDevice: 'Edit Device',
		editSensor: 'Edit Sensor',
		editOrg: 'Edit Organization'
	},
	buttons: {
		add: 'Add',
		edit: 'Edit',
		delete: 'Delete',
		save: 'Save',
		cancel: 'Cancel',
		confirm: 'Confirm',
		diagnose: 'Diagnose',
		startStopRecord: 'Start-Stop Record'
	},
	deviceCom: {
		add: 'Add',
		save: 'Save',
		addDevice: 'Add',
		deviceModelImage: 'Device Model Image'
	},
	sensorCom: {
		add: 'Add',
		save: 'Save',
		addSensor: 'Add'
	},
	orgCom: {
		save: 'Save',
		addOrg: 'Add'
	},
	config: {
		gridLayout: 'Grid Layout',
		superiorDepartment: 'Superior Department',
		orgPlaceholder: 'Organization (Diagnosis)',
		name: 'Name',
		nameRequired: 'Required field cannot be empty',
		icon: 'Icon',
		location: 'Location',
		type: 'Type',
		label1: 'Label 1'
	},
	orgTree: {
		expandAll: 'Expand All',
		collapseAll: 'Collapse All',
		filterPlaceholder: 'Please enter keywords to filter',
		deleteConfirm: 'Are you sure you want to delete this node?',
		deleteTitle: 'Warning'
	},
	index: {
		deviceList: 'Device List',
		startStopRecord: 'Start-Stop Record',
		nodeTitle: {
			device: 'Device',
			sensor: 'Sensor',
			org: 'Organization',
			node: 'Node'
		},
		addNodeTitle: 'Add {type}',
		editNodeTitle: 'Edit {type}'
	}
}
